export default __webpack_public_path__ + "static/media/KOD0112-min.3a6ce1b3.webp";